import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Assests/Scss/Participation.scss";
import { useSelector } from "react-redux";

import InternetChecking from "../Student/Reusablecomponents/Network";
import Loading from "../Student/Reusablecomponents/Loading";
import {
  AssessmentName, CAssessmentName,
  exportToExcel,
} from "../Student/Reusablecomponents/RegularFunctions";
import { IoMdArrowDropright } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { RiFileExcel2Fill } from "react-icons/ri";
import { SlClose } from "react-icons/sl";
import { CiSearch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import Pagination from "../Student/Reusablecomponents/Pagination/Pagination";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import SamagaraDashboard from "../Principle/SamagraFileDashboard/src/App";
import { AssessmentNameDates } from "../ReusableComponents/CommonComponents";
import { IoCloseCircleOutline } from "react-icons/io5";
const Participationtable = () => {
  const navigate = useNavigate();
  const Logitems = useSelector((state) => state.userDetailsData.LoginDetails);
  const Colors = ["#86E3CE", "#CCABD8", "#FFDD94", "#FA897B", "#D0E6A5"];
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const [Details, SetDetails] = useState();
  const [Load, SetLoad] = useState(false);

  const [OpenSD, SetOpenSD] = useState(false);

  const [AParticipation, SetAParticipation] = useState();
  const [AAbsent, SetAAbsent] = useState();
  const [StateId, SetStateId] = useState();

  const [Search, SetSearch] = useState("");
  const [ForSearch, SetForSearch] = useState();
  const [DParticipation, SetDParticipation] = useState();

  const [PCPage, SetPCPage] = useState(1);
  const [Citems, SetCitems] = useState();
  const GetRegionWiseData = async () => {
    SetAParticipation(null);
    SetAAbsent(null);
    SetStateId(null);
    SetLoad((prev) => !prev);
    SetDetails();
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetInsParticipationReport?InstituteId=${Logitems?.instituteId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].region_State) {
          SetDetails(res.data);
        } else {
          SetDetails(SelectDate?.examStartDate ? process.env.REACT_APP_NODATAFOUND_Participated : "No Assessment Schedules found" );
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const RegionDrillDown = async (Level, RHierarchy, SHierarchy, DType) => {
    SetSearch("");
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetInsParticipationReportByLevel?InstituteId=${Logitems?.instituteId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&Level=${Level}&RegionHierarchyId=${RHierarchy}&StateHierarchyId=${SHierarchy}&RepType=${DType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].levelValue) {
          SetForSearch(res.data);
          SetDParticipation(res.data);
          LoadCurrentItems(1, res.data);
        } else {
          SetDParticipation(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filteredData = (SSearch) => {
    const SearchData = ForSearch.filter((row) =>
      row.levelValue?.toString().toLowerCase().includes(SSearch.toLowerCase())
    );
    LoadCurrentItems(1, SearchData);
    SetDParticipation(
      SearchData.length > 0
        ? SearchData
        : process.env.REACT_APP_NODATAFOUND_Participated
    );
  };
  // Below Society
  const GetSocietyRegionWiseData = async () => {
    SetAParticipation(null);
    SetAAbsent(null);
    SetStateId(null);
    SetLoad((prev) => !prev);
    SetDetails();
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyParticipationReport?InstituteId=${Logitems?.instituteId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&SocietyId=${Logitems?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].region_State) {
          SetDetails(res.data);
        } else {
          SetDetails(SelectDate?.examStartDate ? process.env.REACT_APP_NODATAFOUND_Participated : "No Assessment Schedules found");
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const SocietyRegionDrillDown = async (
    Level,
    RHierarchy,
    SHierarchy,
    DType
  ) => {
    SetSearch("");
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/InstitutionAdmin/GetSocietyParticipationReportByLevel?InstituteId=${Logitems?.instituteId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&Level=${Level}&RegionHierarchyId=${RHierarchy}&StateHierarchyId=${SHierarchy}&RepType=${DType}&SocietyId=${Logitems?.societyId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].levelValue) {
          SetForSearch(res.data);
          SetDParticipation(res.data);
          LoadCurrentItems(1, res.data);
        } else {
          SetDParticipation(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above Society

  useEffect(() => {
    if (SelectDate?.value > 0) {
      if (!Logitems?.societyId) {
        GetRegionWiseData();
      } else {
        // SetDetails();
        GetSocietyRegionWiseData();
      }
    } else {
      SetDParticipation(process.env.REACT_APP_NODATAFOUND_Participated);
      SetDetails(SelectDate?.examStartDate ? process.env.REACT_APP_NODATAFOUND_Participated : "No Assessment Schedules found");
    }
  }, [SelectDate?.value]);
  const getTotal = (field) => {
    return Details?.reduce((total, item) => total + item[field], 0);
  };
  const FindLevel = (Levels) => {
    switch (Levels) {
      case "States":
        return 2;
      case "Districts":
        return 3;
      case "Schools":
        return 4;
      case "Reg Students":
        return 5;
    }
  };

  const DHReport = async () => {
    const worksheetData = [
      [
        Logitems?.userTypeId === 8
          ? Logitems?.societyId
            ? "Society"
            : "State"
          : "Region",
        ...Details.map((item) => item.region_State),
        "Total",
      ],
      ...(Logitems?.userTypeId === 8
        ? ["Districts", "Schools", "Reg Students"]
        : ["States", "Districts", "Schools", "Reg Students"]
      ).flatMap((item) => [
        [],
        [
          item,
          ...Details?.map(
            (items) => items?.[item.toLowerCase().replace(" ", "")]
          ),
          getTotal(item.toLowerCase().replace(" ", "")),
        ],
        [
          "Participated",
          ...Details?.map((items) => {
            let abc = items?.[
              `${item.toLowerCase().replace(" ", "")}Participation`
            ]
              ? items?.[`${item.toLowerCase().replace(" ", "")}Participation`]
              : "-";
            let dbc =
              items?.[`${item.toLowerCase().replace(" ", "")}Percent`] + "%";
            return `${abc} (${dbc})`;
          }),
          `${getTotal(
            `${item.toLowerCase().replace(" ", "")}Participation`
          )} (${Math.round(
            (getTotal(`${item.toLowerCase().replace(" ", "")}Participation`) /
              getTotal(item.toLowerCase().replace(" ", ""))) *
            100
          )}%)`,
        ],
        [
          "Not participated",
          ...Details?.map((items) =>
            items?.[`${item.toLowerCase().replace(" ", "")}Absent`]
              ? `${items?.[`${item.toLowerCase().replace(" ", "")}Absent`]
              } (${Math.round(
                (items?.[`${item.toLowerCase().replace(" ", "")}Absent`] /
                  items?.[item.toLowerCase().replace(" ", "")]) *
                100
              )}%)`
              : "-"
          ),
          `${getTotal(
            `${item.toLowerCase().replace(" ", "")}Absent`
          )} (${Math.round(
            (getTotal(`${item.toLowerCase().replace(" ", "")}Absent`) /
              getTotal(item.toLowerCase().replace(" ", ""))) *
            100
          )}%)`,
        ],
      ]),
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      `${Logitems.instituteCode}_OverallParticipation`
    );
    worksheet.addRow([
      `${Logitems.instituteCode} Overall Participation ${AssessmentName(
        SelectDate?.assessmentType
      )} ${SelectDate?.examStartDate} `,
    ]).font = { bold: true };
    worksheet.mergeCells(1, 1, 1, worksheetData[0].length);
    worksheet.getCell("A1").alignment = { horizontal: "center" };
    worksheet.addRow([]);
    worksheetData.forEach((data) => worksheet.addRow(data));
    worksheet.getRow(3).font = { bold: true };
    worksheet.getColumn(1).font = { bold: true };
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${Logitems.instituteCode}_OverallParticipation.xlsx`);
  };

  const DDrillDown = (Region, DType) => {
    const XL = DParticipation?.map((item, index) => {
      const region = Region;
      if (region === "School" && DType === "P") {
        return {
          SNo: index + 1,
          [`${region}`]: item.levelValue,
          District: item.district,
          "Registered Students": item.regstudents,
          "Participated Students": item.regstudentsParticipation,
          "Not Participated Students": item.regstudentsAbsent,
        };
      } else if (region === "School" && DType === "A") {
        return {
          SNo: index + 1,
          [`${region}`]: item.levelValue,
          District: item.district,
          "Registered Students": item.regstudents,
        };
      } else if (DType === "P") {
        return {
          SNo: index + 1,
          [`${region}`]: item.levelValue,
          "Registered Students": item.regstudents,
          "Participated Students": item.regstudentsParticipation,
          "Not Participated Students": item.regstudentsAbsent,
        };
      } else {
        return {
          SNo: index + 1,
          [`${region}`]: item.levelValue,
          "Registered Students": item.regstudents,
        };
      }
    });
    // <div dangerouslySetInnerHTML={{ __html: AssessmentName(e) }} />
    exportToExcel(
      XL,
      `${Logitems.instituteCode}_${SelectDate?.examStartDate}_${LAssessmentName(
        SelectDate?.assessmentType
      )}_${Region}wise${DType === "P" ? "Participated" : "Not Participated"
      }`,
      false,
      `${Region}wise ${DType === "P" ? "Participated" : "Not Participated"}`,
      `${Logitems.instituteCode} ${LAssessmentName(SelectDate?.assessmentType)} ${SelectDate?.examStartDate
      } `
    );
  };
  const LAssessmentName = (e) => {
    const types = {
      1: "SODHANA Assessment",
      2: "SADHANA Assessment",
      3: "SAMAGRA Assessment",
    };

    return types[e] || "";
  }
  const LoadCurrentItems = (e, data) => {
    SetPCPage(e);
    SetCitems(data.slice(e * 10 - 10, e * 10));
  };
  const closeAccordain = () => {
    SetAParticipation(null);
    SetAAbsent(null);
  };
  const handleSearchChange = (e) => {
    filteredData(e);
    SetSearch(e);
  };
  const NSDashboard = (e) => {
    localStorage.setItem("SDetails", JSON.stringify(e));
    SetOpenSD(true);
    // navigate("/SamagraDashboard");
    // window.open("/SamagraDashboard", "_blank");
  }
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="MainHeading">
          Participation   {SelectDate?.examStartDate && (
    <>
      {" in "}
      {CAssessmentName(SelectDate?.assessmentType)}
      {" - "}
      {SelectDate?.examStartDate}
    </>
  )}
        </div>

        <div className="dflex JSBetween">
          {Logitems?.societyId ? (<div className="SubHeading"> <b>Society :</b> {Logitems?.societyName} </div>) : (<div></div>)}
          <div className="dflex">
            {Details?.[0]?.region_State && (
              <div className="ExportExcel dflex alignitems gap-2" onClick={DHReport}> <RiFileExcel2Fill /> Export </div>)}
          </div>
        </div>
        {Details?.[0]?.region_State ? (
          <div className="Table-Card mt-2">
            <table className="EachRegion-Table">
              <thead>
                <tr style={{ backgroundColor: `${Colors[0]}`, textTransform: "uppercase", }} >
                  <th> {Logitems?.userTypeId === 8 ? Logitems?.societyId ? "Society" : "State" : "Region"} </th>
                  {Details?.map((items, Rindex) => (<th key={Rindex}>{items.region_State}</th>))}
                  <th>Total</th>
                </tr>
              </thead>
              {(Logitems?.userTypeId === 8 ? ["Districts", "Schools", "Reg Students"] : ["States", "Districts", "Schools", "Reg Students"]
              ).map((item, index) => (
                <tbody key={index}>
                  <tr colSpan={Details?.length}> <td></td> </tr>

                  <tr key={index}
                    style={{ backgroundColor: `${Colors[index + 1]}` }} >
                    <th>{item}</th>
                    {Details?.map((items, dindex) => (
                      <td key={`${dindex}-${index}`} style={{ fontSize: "17px" }} >
                        {items?.[item.toLowerCase().replace(" ", "")]} </td>))}
                    <th>{getTotal(item.toLowerCase().replace(" ", ""))}</th>
                  </tr>

                  {["Participation", "Absent"].map((Status, twoindex) => (
                    <>
                      <tr>
                        <td style={Status !== "Participation" ? { color: "grey" } : {}} >
                          {Status === "Participation" ? "Participated" : "Not participated"}
                        </td>
                        {Details?.map((items, dindex) => (
                          <td key={`${dindex + 1}-${index}`}
                            className="CPointer"
                            title={`Click here to view the ${item.slice(
                              0, -1)} wise ${Status === "Participation" ? "Participated" : "Not participated"}.`}
                            style={AParticipation === twoindex && AAbsent === index &&
                              StateId === items.region_StateId ? { backgroundColor: "#b4cff0" } : {}}
                            onClick={() => {
                              if (FindLevel(item) < 5 && items?.[`${item.toLowerCase().replace(" ", "")}${Status}`]) {
                                SetDParticipation();
                                if (AParticipation === twoindex &&
                                  AAbsent === index && StateId === items.region_StateId) {
                                  SetAParticipation(null);
                                  SetStateId(null);
                                  SetAAbsent(null);
                                } else {
                                  if (Logitems?.userTypeId === 8) {
                                    if (!Logitems?.societyId) {
                                      RegionDrillDown(FindLevel(item), 0, items.region_StateId, Status === "Participation" ? "P" : "A");
                                    } else {
                                      SocietyRegionDrillDown(FindLevel(item), 0, items.region_StateId, Status === "Participation" ? "P" : "A");
                                    }
                                  } else {
                                    RegionDrillDown(FindLevel(item), items.region_StateId, 0, Status === "Participation" ? "P" : "A");
                                  }
                                  SetAParticipation(twoindex);
                                  SetAAbsent(index);
                                  SetStateId(items.region_StateId);
                                }
                              }
                            }}
                          >
                            <div className="dflex alignitems JCCenter">
                              {items?.[`${item.toLowerCase().replace(" ", "")}${Status}`]
                                ? `${items?.[`${item.toLowerCase().replace(" ", "")}${Status}`]} 
                                (${Status === "Participation"
                                  ? items?.[`${item.toLowerCase().replace(" ", "")}Percent`]
                                  : Math.round((items?.[`${item.toLowerCase().replace(" ", "")}Absent`] /
                                    items?.[item.toLowerCase().replace(" ", "")]) * 100)}%)`
                                : "-"}
                              {items?.[`${item.toLowerCase().replace(" ", "")}${Status}`] ? (
                                <span className="accordion">
                                  {item !== "Reg Students" ? (AParticipation === twoindex && AAbsent === index &&
                                    StateId === items.region_StateId ? (<IoMdArrowDropdown />) : (<IoMdArrowDropright />)) : (" ")}
                                </span>
                              ) : ("")}
                            </div>
                          </td>
                        ))}

                        <td>{`${getTotal(`${item.toLowerCase().replace(" ", "")}${Status}`)
                          ? getTotal(`${item.toLowerCase().replace(" ", "")}${Status}`) : "-"}
                                                        ${Math.round(
                            (getTotal(`${item.toLowerCase().replace(" ", "")}${Status}`) /
                              getTotal(item.toLowerCase().replace(" ", ""))) * 100)
                            ? `(${Math.round(
                              (getTotal(`${item.toLowerCase().replace(" ", "")}${Status}`) /
                                getTotal(item.toLowerCase().replace(" ", ""))) * 100) + "%"})` : ""}`}</td>
                      </tr>
                      {AParticipation === twoindex && AAbsent === index &&
                        StateId && (
                          <tr>
                            <td colSpan={Details?.length + 2}>
                              <div className="Drilldown-maindiv">
                                <div className="dflex alignitems HQDExcel" style={{ justifyContent: "right" }} >
                                  <div className="Search">
                                    {Search.length === 0 && <CiSearch />}
                                    <input type="text" placeholder="Search..." value={Search} style={{ paddingLeft: Search ? "20px" : "30px", }}
                                      onChange={(e) => handleSearchChange(e.target.value)} />
                                    {Search.length > 0 && (<IoMdClose onClick={() => { SetSearch(""); handleSearchChange(""); }} />)}
                                  </div>
                                  <div className="ExportExcel dflex alignitems gap-1"
                                    onClick={() => DDrillDown(item.slice(0, -1), Status === "Participation" ? "P" : "A")}
                                    title={`Download ${item.slice(0, -1)} wise ${Status === "Participation" ? "Participated" : "Not participated"}`} >
                                    <RiFileExcel2Fill /> Export
                                  </div>
                                  <SlClose className="AClose" onClick={closeAccordain} title="Close" />
                                </div>
                                <table className="w-100 EachParticipation-table">
                                  <thead>
                                    <tr style={{ backgroundColor: "rgba(28, 162, 122, 0.1)", }} >
                                      <th>S.No</th>
                                      <th>{item.slice(0, -1)}</th>
                                      {item === "Schools" && <th>District</th>}
                                      <th>Registered Students</th>
                                      {Status === "Participation" && (
                                        <>
                                          <th>Participated Students</th>
                                          <th>Not participated Students</th>
                                        </>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody style={{ textAlign: "center" }}>
                                    {DParticipation?.[0]?.levelValue ? (
                                      Citems?.map((Sitem, index) => (
                                        <tr key={index}>
                                          <td> {index + 1 + (PCPage * 10 - 10)} </td>
                                          <td className={`CPointer ${SelectDate?.assessmentType === 3 && item === "Schools" && Status === "Participation" ? "LinkStyles" : ""}`}
                                            onClick={() => SelectDate?.assessmentType === 3 && item === "Schools" && Status === "Participation" && NSDashboard(Sitem)}>{Sitem.levelValue}</td>
                                          {item === "Schools" && (<td>{Sitem.district}</td>)}
                                          <td>{Sitem.regstudents}</td>
                                          {Status === "Participation" && (
                                            <>
                                              <td> {Sitem.regstudentsParticipation} </td>
                                              <td>{Sitem.regstudentsAbsent}</td>
                                            </>
                                          )}
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="6" className="ErrorMessage" > {DParticipation} </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                                {DParticipation?.[0]?.levelValue &&
                                  DParticipation?.length > 10 && (
                                    <div className="m-2">
                                      <Pagination currentPage={PCPage} Recorsperpage={10}
                                        totalPages={Math.ceil(DParticipation?.length / 10)}
                                        Totalrecords={DParticipation?.length}
                                        onPageChange={(e) => { LoadCurrentItems(e, DParticipation); }}
                                      />{" "}
                                    </div>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )}
                    </>
                  ))}
                </tbody>
              ))}
            </table>
            <div className="Info-Message">
              Click on the <b> Participated/Not Participated numbers</b> to view
              the detailed participation and absentees list.
            </div>
          </div>
        ) : (
          <div className="ErrorMessage">{Details}</div>
        )}
        {Load && <Loading />}
      </div>
      {OpenSD &&
        <div className="Model-Open py-2 px-0">
          <div className="Card w-100 p-0 Model-Content">
            <div className="dflex JSBetween" style={{ color: "black", }}>
              <div></div>
              <div className="CPointer" style={{ position: "fixed", zIndex: '110', right: "40px", top: "35px", fontSize: "30px" }}
              onClick={()=>SetOpenSD(false)}>
                <IoCloseCircleOutline /></div>
            </div>
            <SamagaraDashboard />
          </div></div>
      }
    </>
  );
};
export default Participationtable;